export default "__VITE_ASSET__Cg$XONtJ__"